import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { GoogleLoginButton } from "react-social-login-buttons"; //FacebookLoginButton
import { useToasts } from "react-toast-notifications";
import { useHistory } from "react-router-dom";

import { startAuth, googleAuth, clearError } from "../../Store/actions/index"; //facebookAuth
import pcariLogo from "../../assets/svg/Seller/pcariLogo.svg";
import pcariTransBack from "../../assets/svg/Seller/pcariTransBack.svg";
import arrowIncircle from "../../assets/svg/Seller/arrowIncircle.svg";
import arrowInCircleBlack from "../../assets/svg/Seller/arrowInCircleBlack.svg";
import arrwBackInCircle from "../../assets/svg/Seller/arrwBackInCircle.svg";
import googelplay from "../../assets/Img/restyle/googelplay.png";
import classes from "./welcome.module.css";

const Welcome = (props) => {
  const [show, setShow] = useState(false);
  const [mode, setMode] = useState("sign-in");
  const history = useHistory();
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const { error } = useSelector((state) => state.Auth);

  const handleClose = () => setShow(false);
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .email("Must be a valid email address")
        .max(100, "Email must be less than 100 characters")
        .required("Email is required"),
      password: Yup.string()
        .max(100, "Password must be less than 100 characters")
        .required("Password is required"),
    }),
    onSubmit: (values) => {
      dispatch(startAuth(values.email, values.password, "signIn"));
    },
  });
  const restFormik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .email("Must be a valid email address")
        .max(100, "Email must be less than 100 characters")
        .required("Email is required"),
    }),
    onSubmit: (values) => {
      dispatch(startAuth(values.email, undefined, "passwordReset"));
      setMode("sign-in");
    },
  });

  const { setErrors } = formik;

  useEffect(() => {
    if (error) {
      if (error.startsWith("Your email address is not verified")) {
        addToast(error, { appearance: "warning", autoDismiss: false });
      } else
        setErrors({
          email: "invalide email or password",
          password: "invalide email or password",
        });
    }
  }, [error, setErrors, addToast]);

  return (
    <div className={classes.Container}>
      <img
        className={classes.Trans}
        src={pcariTransBack}
        alt="Trans"
        data-aos="fade-down"
        data-aos-duration="800"
        data-aos-delay="200"
      />
      {/*  LEFT SIDE */}
      <div
        className={classes.Left}
        data-aos="fade-right"
        data-aos-duration="800"
        data-aos-delay="200"
      >
        <img src={pcariLogo} alt="pcari" />
        <p className={classes.Unlesh}>
          Unleash Your Selling
          <br /> Potential With pcari.my
        </p>
        <p className={classes.Hello}>
          Hello <br />
          Seller
        </p>
        <div className={classes.Container}>
          <div className={classes.BtnWrap}>
            <p>Already have an account?</p>
            <button className={classes.Btn} onClick={(event) => setShow(true)}>
              Sign In
              <img src={arrowIncircle} alt="singin" />
            </button>
          </div>
          <div className={classes.BtnWrap}>
            <p>Don’t have an account ?</p>
            <button
              className={`${classes.Btn} ${classes.Yellow}`}
              onClick={(event) => {
                history.push({ pathname: "/Register" });
                dispatch(clearError());
              }}
            >
              Create
              <img src={arrowInCircleBlack} alt="singin" />
            </button>
          </div>
        </div>
        <button
          className={`${classes.Btn} ${classes.Black}`}
          onClick={(event) => (window.location = "https://auto.pcari.my/")}
        >
          Back to Vehicle Seach
          <img src={arrwBackInCircle} alt="singin" />
        </button>

        <img
          onClick={(event) =>
            (window.location =
              "https://play.google.com/store/apps/details?id=com.pcari.pcari_user")
          }
          className={classes.OnlySmall}
          src={googelplay}
          alt="google play"
        />
      </div>

      {/*  RIGHT SIDE */}
      <div
        className={classes.Right}
        data-aos="zoom-in"
        data-aos-duration="800"
        data-aos-delay="200"
      >
        <img
          onClick={(event) =>
            (window.location =
              "https://play.google.com/store/apps/details?id=com.pcari.pcari_user")
          }
          src={googelplay}
          alt="google play"
        />
        <p>Available Now</p>
        <p>© 2020 pcari.my. All Rights Reserved</p>
      </div>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton className="border-0" />
        {mode === "sign-in" ? (
          <Modal.Body>
            <Row>
              <Col>
                <img
                  src={pcariLogo}
                  alt="pcari"
                  width="40%"
                  style={{ margin: "2% 30%" }}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <GoogleLoginButton onClick={(e) => dispatch(googleAuth())} />
              </Col>
            </Row>
            {/* <Row>
              <Col>
                <FacebookLoginButton onClick={e => dispatch(facebookAuth())} />
              </Col>
            </Row> */}
            <Row>
              <Col>
                <hr />
              </Col>
              <Col xs={1}>
                <p className="text-center text-tertiary">or</p>
              </Col>
              <Col>
                <hr />
              </Col>
            </Row>
            <Form noValidate onSubmit={formik.handleSubmit}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Username / Email Address"
                  isValid={formik.touched.email && !formik.errors.email}
                  isInvalid={formik.touched.email && formik.errors.email}
                  {...formik.getFieldProps("email")}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.email}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Control
                  type="password"
                  name="password"
                  placeholder="Password"
                  isValid={formik.touched.password && !formik.errors.password}
                  isInvalid={formik.touched.password && formik.errors.password}
                  {...formik.getFieldProps("password")}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.password}
                </Form.Control.Feedback>
              </Form.Group>
              <div className="d-grid my-4">
                <Button variant="primary text-white" type="submit">
                  LOG IN
                </Button>
              </div>
              <Form.Group>
                <p className="text-center mt-3 text-tertiary">
                  Don’t have an account?{" "}
                  <small
                    onClick={() => {
                      formik.resetForm();
                      history.push({ pathname: "/Register" });
                      dispatch(clearError());
                    }}
                    className="link-primary cursor-pointer"
                  >
                    Create a free account
                  </small>
                </p>
              </Form.Group>
              <Form.Group>
                <p className="text-center mt-3 text-tertiary">
                  <small>Forgot your password? </small>
                  <small
                    onClick={() => {
                      formik.resetForm();
                      setMode("password-reset");
                    }}
                    className="link-primary cursor-pointer"
                  >
                    Rest password
                  </small>
                </p>
              </Form.Group>
            </Form>
          </Modal.Body>
        ) : (
          <Modal.Body>
            <Row>
              <Col>
                <h4 className="text-center text-tertiary">
                  Forgot your password ?
                </h4>
                <p className="text-center text-tertiary">
                  Enter your email to get password rest email.
                </p>
              </Col>
            </Row>
            <Form noValidate onSubmit={restFormik.handleSubmit}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label className="text-tertiary">Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Username / Email Address"
                  isValid={restFormik.touched.email && !restFormik.errors.email}
                  isInvalid={
                    restFormik.touched.email && restFormik.errors.email
                  }
                  {...restFormik.getFieldProps("email")}
                />
                <Form.Control.Feedback type="invalid">
                  {restFormik.errors.email}
                </Form.Control.Feedback>
              </Form.Group>

              <div className="d-grid my-4">
                <Button variant="primary text-white" type="submit">
                  Send Email
                </Button>
              </div>
              <Form.Group>
                <p className="text-center mt-3 text-tertiary">
                  Don’t have an account?{" "}
                  <small
                    onClick={() => {
                      restFormik.resetForm();
                      history.push({ pathname: "/Register" });
                      dispatch(clearError());
                    }}
                    className="link-primary cursor-pointer"
                  >
                    Create a free account
                  </small>
                </p>
              </Form.Group>
              <Form.Group>
                <p className="text-center mt-3 text-tertiary">
                  <small>Back to </small>
                  <small
                    onClick={() => {
                      restFormik.resetForm();
                      setMode("sign-in");
                    }}
                    className="link-primary cursor-pointer"
                  >
                    Sign in
                  </small>
                </p>
              </Form.Group>
            </Form>
          </Modal.Body>
        )}
      </Modal>
    </div>
  );
};

export default Welcome;
